import { Head } from "@inertiajs/react";
import { t } from "@travily/i18n";
import {
  foundingMemberCreatorPath,
  foundingMemberCreatorPausePath,
  foundingMemberCreatorStagePath,
} from "@travily/routes";
import type FoundingMemberCreatorIndividualExperience from "@travily/types/pages/FoundingMemberCreatorIndividualExperience";
import { useCreatorTopBarActions } from "@/lib/wizard/use-creator-top-bar-actions";
import { useWizardForm } from "@/lib/wizard/use-wizard-form";
import { ExperienceStepView } from "./show.view";

type FormData = {
  individual_profile: {
    educator_experience: number;
  };
};

const FIELD = "individual_profile.educator_experience";

const ExperienceStep = ({
  stage_index,
  stage_order,
  individual_profile,
}: FoundingMemberCreatorIndividualExperience) => {
  const { form, validate, fieldError, currentStage, totalStages, onBack, onPrimary, primaryPending, onPause } =
    useWizardForm<FormData>({
      routes: {
        stageUrl: (stage) => foundingMemberCreatorStagePath("individual", stage),
        entryUrl: foundingMemberCreatorPath(),
        pauseUrl: foundingMemberCreatorPausePath(),
      },
      stageName: "experience",
      stageIndex: stage_index,
      stageOrder: stage_order,
      initialData: { individual_profile: { educator_experience: individual_profile.educator_experience ?? 1 } },
    });

  const error = fieldError(FIELD);

  const topBarActions = useCreatorTopBarActions({ onPause });

  return (
    <>
      <Head title={t("web.founding_members.creator.steps.individual.experience.show.meta_title")}>
        <meta
          name="description"
          content={t("web.founding_members.creator.steps.individual.experience.show.meta_description")}
        />
      </Head>
      <ExperienceStepView
        currentStage={currentStage}
        totalStages={totalStages}
        onBack={onBack}
        topBarActions={topBarActions}
        isPending={primaryPending}
        value={form.data.individual_profile.educator_experience}
        error={error}
        onChange={(value) => {
          form.setData(FIELD, value);
          validate(FIELD);
        }}
        onContinue={onPrimary}
      />
    </>
  );
};

export default ExperienceStep;
